import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=ff72b6e2&scoped=true&"
import script from "./AppFooter.vue?vue&type=script&lang=ts&"
export * from "./AppFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff72b6e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/app-root/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff72b6e2')) {
      api.createRecord('ff72b6e2', component.options)
    } else {
      api.reload('ff72b6e2', component.options)
    }
    module.hot.accept("./AppFooter.vue?vue&type=template&id=ff72b6e2&scoped=true&", function () {
      api.rerender('ff72b6e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/GPortal/Frontend/vue/view/footer/AppFooter.vue"
export default component.exports